import React from 'react';
import { useNavigate } from 'react-router-dom';
import CadastroPdv from './CadastroPdv';
import { cadastrarPdv, atualizarModulosLicenca } from '../services/api';

const NovoPDV = ({ token }) => {
  const navigate = useNavigate();

  const handleSubmit = async (data, token, { itensModulos = [] } = {}) => {
    const resp = await cadastrarPdv(data, token);
    const novoId = resp?.data?.id;
    if (novoId && itensModulos.length > 0) {
      await atualizarModulosLicenca('ZenPDV', novoId, itensModulos, token);
    }
  };

  return (
    <CadastroPdv
      onSubmit={handleSubmit}
      token={token}
      successMessage="PDV cadastrado com sucesso!"
      onSaveSuccess={() => navigate('/licenciamento/zenpdv')}
    />
  );
};

export default NovoPDV;
